import React, { useState, useEffect } from 'react';
import lockFrame from '../assets/login password.png';
import logoFont from '../assets/logo font.png';
import { Link, useNavigate } from 'react-router-dom';
import api from '../sever/Api';
import { toast } from 'react-toastify';
import esscoBg from '../assets/essco-bg.png';
import logo1 from '../assets/new-Logo.png';
import textlogo from '../assets/UnlockYourPotential.png';
import logo from '../assets/logo PNG Transparent/Logo-10.png';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    // Check if user has valid OTP and email
    useEffect(() => {
        const email = localStorage.getItem('resetEmail');
        const otp = localStorage.getItem('resetOTP');

        if (!email || !otp) {
            toast.error('Please complete the OTP verification first');
            navigate('/forgotpassword');
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }

        if (password.length < 6) {
            toast.error('Password must be at least 6 characters long');
            return;
        }

        // Check password strength
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;
        if (!passwordRegex.test(password)) {
            toast.error('Password must contain at least one uppercase letter, one lowercase letter, and one number');
            return;
        }

        setIsLoading(true);
        try {
            const email = localStorage.getItem('resetEmail');
            const otp = localStorage.getItem('resetOTP');

            if (!email || !otp) {
                toast.error('Session expired. Please try again.');
                navigate('/forgotpassword');
                return;
            }

            const response = await api.post('/api/auth/reset-password', {
                email,
                otp,
                newPassword: password
            });

            toast.success('Password reset successfully! You can now login with your new password.');

            // Clear stored data
            localStorage.removeItem('resetEmail');
            localStorage.removeItem('resetOTP');

            // Redirect to login
            navigate('/login');
        } catch (error) {
            console.error('Password reset error:', error);
            const message = error.response?.data?.message || 'Failed to reset password. Please try again.';
            toast.error(message);
        } finally {
            setIsLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    return (
        <>
            <div className=' min-h-screen bg-[linear-gradient(126.39deg,#F7F6FA_5.58%,#F5F4FC_27.79%,#F2F2FE_48.29%,#F5F4FF_69.65%,#FFF9FF_94.42%)]' style={{
                backgroundImage: `url(${esscoBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className="flex flex-row justify-center items-center px-[32px] py-[16px] bg-[rgba(247,248,250,0.01)] shadow-[0px_2px_7px_rgba(0,0,0,0.07)]" >
                    <img src={logo1} alt="HWORK2 Logo" style={{ width: 215, height: 41 }} />
                </div>
                <div className="mt-6 w-full overflow-x-hidden flex items-center justify-center ">


                    {/* Main Login Card */}
                    <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
                        {/* Card Header */}
                        <div className="text-center mb-8">
                            <div className=" flex items-center justify-center mx-auto mb-4 relative" style={{ width: 123 }}>
                                <img src={logo} alt="HWORK2 Logo" className="w-full h-full" />
                            </div>
                            <h1 className="font-semibold text-[24px] leading-[32px] text-center text-[#151417] mb-2" style={{ fontFamily: 'Lato, sans-serif' }}>The HWORK2 Method</h1>
                            {/* <p className="text-purple-600 italic"style={{fontFamily: 'Playfair Display, serif', fontSize:32}}>Unlock Your Potential</p> */}
                            <img src={textlogo} alt="HWORK2 Logo" className="w-full h-full" />
                        </div>
                        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
                            {/* New Password */}
                            <div>
                                <label className="block font-semibold mb-1 text-gray-800 text-sm sm:text-base">New Password</label>
                                <div className="flex items-center border-2 border border-gray-300 rounded-lg px-2 py-2 focus-within:border-purple-500 transition">
                                    <img src={lockFrame} alt="lock" className="w-4 h-4 sm:w-5 sm:h-5 mr-2 opacity-80" />
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Enter new password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="flex-1 bg-transparent outline-none text-gray-800 placeholder-gray-400 text-sm sm:text-base"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={togglePasswordVisibility}
                                        className="ml-2 p-1 rounded-full hover:bg-gray-100 transition-colors duration-200 "
                                        title={showPassword ? "Hide password" : "Show password"}
                                    >
                                        {showPassword ? (
                                            // Eye closed icon (password hidden)
                                            <svg
                                                className="w-5 h-5 text-gray-600"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                                                />
                                            </svg>
                                        ) : (
                                            // Eye open icon (password visible)
                                            <svg
                                                className="w-5 h-5 text-gray-600"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                />
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Confirm Password */}
                            <div>
                                <label className="block font-semibold mb-1 text-gray-800 text-sm sm:text-base">Confirm Password</label>
                                <div className="flex items-center border-2 border border-gray-300 rounded-lg px-2 py-2 focus-within:border-purple-500 transition">
                                    <img src={lockFrame} alt="lock" className="w-4 h-4 sm:w-5 sm:h-5 mr-2 opacity-80" />
                                    <input
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        placeholder="Confirm new password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        className="flex-1 bg-transparent outline-none text-gray-800 placeholder-gray-400 text-sm sm:text-base"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={toggleConfirmPasswordVisibility}
                                        className="ml-2 p-1 rounded-full hover:bg-gray-100 transition-colors duration-200 "
                                        title={showConfirmPassword ? "Hide password" : "Show password"}
                                    >
                                        {showConfirmPassword ? (
                                            // Eye closed icon (password hidden)
                                            <svg
                                                className="w-5 h-5 text-gray-600"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                                                />
                                            </svg>
                                        ) : (
                                            // Eye open icon (password visible)
                                            <svg
                                                className="w-5 h-5 text-gray-600"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                />
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>

                            <button
                                type="submit"
                                disabled={isLoading}
                                className="w-full py-2 sm:py-3 rounded bg-gradient-to-r from-[#7A81FF] to-[#7A81FF] text-white font-bold shadow-md text-sm sm:text-base lg:text-lg mt-4 hover:shadow-lg transition-shadow disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {isLoading ? 'Resetting Password...' : 'Reset Password'}
                            </button>

                            {/* Back to Login Link */}
                            <div className="text-center">
                                <Link to="/login" className="text-gray-600 underline hover:text-gray-800 font-medium font-[14px]">
                                    ← Back to Login
                                </Link>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

        </>
    );
};

export default ResetPassword; 